export const CONTENT_RENDER_MODE_RUNTIME_PROBE_INSTANCE_ID =
  "content-render-mode-toggle-runtime-v1";
export const CONTENT_RENDER_MODE_RUNTIME_PROBE_FEATURE =
  "content-render-mode-toggle-runtime";
export const CONTENT_RENDER_MODE_RUNTIME_PROBE_ACCORDION_COMPONENT =
  "ContentMarkdownAccordion";
export const CONTENT_RENDER_MODE_RUNTIME_PROBE_PREFERENCES_COMPONENT =
  "UserPreferencesSessionFold";
export const CONTENT_RENDER_MODE_RUNTIME_PROBE_SET_PREFERENCES_SOURCE =
  "useSetSessionFoldPreferences";
export const CONTENT_RENDER_MODE_RUNTIME_PROBE_SEED_PREFERENCES_SOURCE =
  "useSeedSessionFoldPreferencesIfAbsent";

export enum ContentRenderModeRuntimeProbeEvent {
  AccordionParserResult = "accordion-parser-result",
  PreferenceMergeResolved = "preference-merge-resolved",
  PreferenceSetRequested = "preference-set-requested",
  PreferenceSeedResolved = "preference-seed-resolved",
  PreferenceSeedRequested = "preference-seed-requested",
  ViewModelSelected = "view-model-selected",
}

export enum ContentRenderModeRuntimeProbeBranch {
  AccordionRows = "accordion-rows",
  AlreadySeeded = "already-seeded",
  EmptySessionId = "empty-session-id",
  FallbackFullMarkdown = "fallback-full-markdown",
  SeedApplied = "seed-applied",
  SingleTitleBlock = "single-title-block",
}
